import styled from 'styled-components';

import { MdDarkMode, MdLightMode } from 'react-icons/md';

export const DarkThemeIcon = styled(MdDarkMode)`
  color: ${(props) => props.theme.colors.primary};
  cursor: pointer;
`;

export const LightThemeIcon = styled(MdLightMode)`
  color: ${(props) => props.theme.colors.primary};
  cursor: pointer;
`;
